export function setCaretAfterElement(document, element, selection) {
  if (!document) {
    return;
  }

  if (!element) {
    return;
  }

  if (!selection) {
    return;
  }

  // Create a temporary zero width character
  const zeroWidthCharacter = document.createTextNode("\u200B");

  // Insert the zero width character after the format element
  element.parentNode.insertBefore(zeroWidthCharacter, element.nextSibling);

  // Set the selection after the zero width character
  const newRange = document.createRange();
  newRange.setStartAfter(zeroWidthCharacter);
  newRange.setEndAfter(zeroWidthCharacter);
  selection.removeAllRanges();
  selection.addRange(newRange);

  return;
}
